import updateHeader from './updateHeader.js'

function transitions() {
  const ensureTurnstileRendered = () => {
    if (!window.turnstile || typeof window.turnstile.render !== 'function') {
      return
    }

    document.querySelectorAll('.wpcf7 .cf-turnstile').forEach((widget) => {
      if (widget.dataset.atTurnstileRendered === '1') {
        return
      }

      if (widget.querySelector('iframe')) {
        widget.dataset.atTurnstileRendered = '1'
        return
      }

      try {
        const widgetId = window.turnstile.render(widget)
        widget.dataset.atTurnstileRendered = '1'
        if (widgetId !== undefined && widgetId !== null) {
          widget.dataset.atTurnstileWidgetId = String(widgetId)
        }
      } catch (_) {
      }
    })
  }

  // URLs que deben excluirse de las transiciones
  const excludedPaths = [
    // '/blog',
    // Agregar más rutas aquí si es necesario
    // '/otra-ruta',
  ]

  if (navigation.addEventListener) {
    navigation.addEventListener('navigate', (event) => {
      const isDesktopViewport = document.documentElement.clientWidth >= 992
      if (!isDesktopViewport || !document.startViewTransition) {
        return
      }

      const isDownloadNavigation = 'downloadRequest' in event && event.downloadRequest !== null
      if (isDownloadNavigation) {
        return
      }

      // Verificar si la URL es externa
      if (!event.destination.url.includes(document.location.origin)) {
        return;
      }

      // Verificar si la URL está en la lista de excluidas ANTES de interceptar
      const destinationUrl = new URL(event.destination.url)
      const destinationPath = destinationUrl.pathname
      const isExcludedPath = excludedPaths.some(path => destinationPath.includes(path))
      const hasBlogFilterParams = destinationUrl.searchParams.has('page') || destinationUrl.searchParams.has('search') || destinationUrl.searchParams.has('category') || destinationUrl.searchParams.has('clean')

      if (isExcludedPath || hasBlogFilterParams) {
        // DEBUG: console.log(`🚫 Transición omitida para: ${destinationPath}`)
        // No interceptar, dejar que la navegación continúe normalmente
        return;
      }

      // Solo interceptar si NO está excluida
      event.intercept({
        async handler() {
          const response = await fetch(event.destination.url);
          const text = await response.text();
          let postSwapDelayMs = 50

          const transition = document.startViewTransition(() => {
            // Parsear HTML usando DOMParser
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            
            // Extraer y actualizar atributos del body
            const newBody = doc.querySelector('body');
            updateHeader(newBody)
            
            // Agregar clase de transición después de actualizar el body
            document.body.classList.add('page-transitioning');
            
            // Extraer contenido del transition-wrapper
            const newWrapper = doc.querySelector('.transition-wrapper');
            const wrapper = document.querySelector('.transition-wrapper');

            if (newWrapper && wrapper) {
              wrapper.innerHTML = newWrapper.innerHTML;
              
              // Re-ejecutar scripts inline del nuevo contenido
              const scripts = wrapper.querySelectorAll('script');
              postSwapDelayMs = Math.max(postSwapDelayMs, scripts.length * 10 + 30)
              // console.log(`Re-ejecutando ${scripts.length} scripts...`);
              
              scripts.forEach((script, index) => {
                // Pequeño delay entre scripts para evitar conflictos
                setTimeout(() => {
                  const newScript = document.createElement('script');
                  
                  // Copiar atributos (type, src, etc.)
                  Array.from(script.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                  });
                  
                  // Copiar contenido si es inline
                  if (!script.src) {
                    newScript.textContent = script.textContent;
                  }
                  
                  // Reemplazar script antiguo con nuevo para forzar ejecución
                  script.parentNode.replaceChild(newScript, script);
                  // console.log(`Script ${index + 1} ejecutado`);
                }, index * 10);
              });
              
            }

            // Actualizar título
            const newTitle = doc.querySelector('title');
            if (newTitle) {
              document.title = newTitle.textContent;
            }
          });

          transition.ready.then(() => {
            window.scrollTo(0, 0);
            
            // Pequeño delay para asegurar que scripts se ejecuten después del DOM
            setTimeout(() => {
              ensureTurnstileRendered();
              window.dispatchEvent(new CustomEvent('cf7-transition-dom-ready'));
              // Disparar evento para re-inicializar módulos
              window.dispatchEvent(new CustomEvent('page-transition-complete'));
            }, postSwapDelayMs);
            
          });
        },
        scroll: 'manual'
      });

    });
  }
}

export default transitions
